import { getDatePickerValues } from '../../../../inputs/DateTimePicker/getDatePickerValues'
import { TimeFormats } from '../../../DateTime/types'
import { PeriodPicker } from '../../../../inputs/PeriodPicker/PeriodPicker'
import React from 'react'
import styles from '../../Styles/index.module.scss'
import { DATE_PERIOD, FROM, PluginSchedule, TO } from './lib/PluginSchedule'

interface ScheduleDatesProps {
    period: PluginSchedule['date_period']
    dataPath: string[]
    onDateFromChange: (path: string[], date: Date | null) => void
    onDateToChange: (path: string[], date: Date | null) => void

}

export const ScheduleDates = (props: ScheduleDatesProps) => {
    const { period, dataPath, onDateFromChange, onDateToChange } = props
    const path = [...dataPath, DATE_PERIOD]

    const dateFrom = getDatePickerValues(
        TimeFormats.DATE,
        { [FROM]: period.from },
        FROM
    ).selected

    const dateTo = getDatePickerValues(
        TimeFormats.DATE,
        { [TO]: period.to },
        TO
    ).selected

    const handleDateFromChange = (date: Date | null) => {
        onDateFromChange([...path, FROM], date)

    }

    const handleDateToChange = (date: Date | null) => {
        onDateToChange([...path, TO], date)
    }

    return (
        <PeriodPicker
            className={`${styles.periodPicker}`}
            containerClassName={styles.container}
            periodType="date"
            dateFrom={dateFrom}
            dateTo={dateTo}
            onDateFromChange={handleDateFromChange}
            onDateToChange={handleDateToChange}
        />
    )
}
